import { Role } from '@/auth/roles'

/**
 * Written out rather than built as `users.roles.${role}`: the catalogue keys are typed, so a role
 * without a translation fails the build instead of rendering its key.
 */
export const ROLE_LABEL_KEYS = {
  [Role.ADMIN]: 'users.roles.ADMIN',
  [Role.SALES]: 'users.roles.SALES',
} as const

/** One line on what the role actually lets somebody do — shown where the role is chosen. */
export const ROLE_HINT_KEYS = {
  [Role.ADMIN]: 'users.roleHint.ADMIN',
  [Role.SALES]: 'users.roleHint.SALES',
} as const
